// @flow
import styled from "styled-components"

export const SearchResultsCountWrap = styled.div`
  text-align: center;
  padding-bottom: 2.4rem;
`



// WEBPACK FOOTER //
// ./src/pages/Search/SearchResults/SearchResultsCount/styled.js